import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { QineticNegotiationApi } from "../../orchestrator-api-client";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";
import { error } from "../../utilities/logger.ts";

export const deselectInsuranceAction = createAsyncThunk<void, void, ThunkApi>(
  "deselectInsurance",
  async (_, { rejectWithValue }) => {
    try {
      await new QineticNegotiationApi().deselectInsurance();
    } catch (e: any) {
      pushErrorMonitor(e); //send error push monitor
      error(e);
      const err: LayoutError = {
        title: "Download Secci",
        description:
          "Ops, qualcosa è andato storto.\n Puoi riprovare o contattare il supporto",
        error: e.message,
      };
      return rejectWithValue(err);
    }
  },
);
